import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerRange.css';

const DatePickerRange = ({ getStartTime, getEndTime, startTime, endTime }) => {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    useEffect(() => {
        sendStartTime(); sendEndTime();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setStartDate(moment(startTime).toDate())
        setEndDate(moment(endTime).toDate())
    },[startTime,endTime])

    const sendStartTime = (data) => {
        getStartTime(data);
    }

    const sendEndTime = (data) => {
        getEndTime(data);
    }

    return (
        <>
            <DatePicker
                minDate={moment().toDate()}
                isClearable
                placeholderText="Select Start Date &amp; Time"
                showTimeSelect
                dateFormat="dd MMMM, yyyy, h:mmaa"
                selected={startDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                onChange={(date) => {setStartDate(date); sendStartTime(date)}}
            />
            <DatePicker
                filterDate={(date) => {
                    return moment() < date;
                }}
                isClearable
                placeholderText="Select End Date &amp; Time"
                showTimeSelect
                dateFormat="dd MMMM, yyyy, h:mmaa"
                selected={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                onChange={(date) => {setEndDate(date); sendEndTime(date)}}
            />
        </>
    );
};

export default DatePickerRange;
